import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

export default function BusinessSolutions() {
  const [isLoading, setIsLoading] = useState(true);
  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };

  const toggleSection = (sectionId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  return (
    <div className="business-solutions-page">
      <style jsx>{`
        :root {
          --theme-color: #f7bf68;
        }
        .business-solutions-page {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #333;
          line-height: 1.6;
        }

        /* Page Title Styles */
        .page-title .content-box h1 {
          color: #fff;
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 15px;
        }

        /* Main Content Styles */
        .business-content {
          padding: 60px 0;
          background-color: #f9fafc;
        }

        .content-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        /* Content Sections */
        .content-section {
          background: white;
          padding: 30px;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          margin-bottom: 30px;
        }

        .section-header {
          margin-bottom: 25px;
          text-align: center;
        }

        .section-header h2 {
          color: var(--theme-color);
          font-size: 28px;
          margin-bottom: 10px;
          font-weight: 700;
        }

        .section-header p.subtitle {
          color: #6b7280;
          font-size: 18px;
          max-width: 800px;
          margin: 0 auto;
        }

        /* Expandable Sections */
        .expandable-section {
          margin-bottom: 20px;
        }

        .section-header-toggle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          padding: 15px;
          background: #f8fafc;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .section-header-toggle:hover {
          background: #f1f5f9;
        }

        .section-header-toggle h3 {
          margin: 0;
          color: var(--theme-color);
          display: flex;
          align-items: center;
        }

        .section-icon {
          margin-right: 10px;
        }

        .section-content {
          padding: 20px;
          background: white;
          border-radius: 0 0 8px 8px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          margin-top: -5px;
        }

        .toggle-icon {
          font-size: 18px;
          transition: transform 0.3s ease;
        }

        .toggle-icon.rotated {
          transform: rotate(180deg);
        }

        /* Styled List */
        .styled-list {
          list-style-type: none;
          padding-left: 0;
        }

        .styled-list li {
          position: relative;
          padding-left: 25px;
          margin-bottom: 10px;
          line-height: 1.6;
        }

        .styled-list li:before {
          content: '•';
          color: var(--theme-color);
          font-weight: bold;
          position: absolute;
          left: 0;
        }

        /* Image Styling */
        .content-image {
          max-width: 50%;
          height: auto;
          border-radius: 8px;
          margin: 20px 0;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        }

        .image-wrapper {
          position: relative;
          overflow: hidden;
          border-radius: 8px;
          margin: 20px 0;
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 50%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          color: white;
          padding: 20px;
          border-radius: 8px;
          transform: translateY(100%);
          opacity: 0;
          transition: transform 0.3s ease, opacity 0.3s ease;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          overflow-y: auto;
        }

        .image-wrapper:hover .image-overlay {
          transform: translateY(0);
          opacity: 1;
        }

        .image-overlay h4 {
          margin: 0 0 10px;
          font-size: 18px;
          color: var(--theme-color);
        }

        .image-overlay ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
        }

        .image-overlay li {
          margin-bottom: 8px;
          position: relative;
          padding-left: 20px;
        }

        .image-overlay li:before {
          content: '•';
          color: var(--theme-color);
          position: absolute;
          left: 0;
          font-weight: bold;
        }

        /* Responsive Adjustments */
        @media (max-width: 768px) {
          .content-section {
            padding: 20px;
          }
          .content-image {
            max-width: 100%;
          }
        }
      `}</style>

      <div className="boxed_wrapper ltr">
        {isLoading && (
          <div className="loader-wrap">
            <div className="preloader">
              <div className="preloader-close">close</div>
              <div id="handle-preloader" className="handle-preloader">
                <div className="animation-preloader">
                  <div className="txt-loading">
                    <img src="assets/images/animation_logo.gif" alt="img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div id="search-popup" className="search-popup">
          <div className="popup-inner">
            <div className="upper-box">
              <figure className="logo-box">
                <a href="index.html">
                  <img src="assets/images/logo-2.png" alt="" />
                </a>
              </figure>
              <div className="close-search">
                <span className="fas fa-times"></span>
              </div>
            </div>
            <div className="overlay-layer"></div>
            <div className="auto-container">
              <div className="search-form">
                <form method="post" action="index.html">
                  <div className="form-group">
                    <fieldset>
                      <input
                        type="search"
                        className="form-control"
                        name="search-input"
                        defaultValue="Read-only content"
                        placeholder="Type your keyword and hit"
                        required
                      />
                      <button type="submit">
                        <i className="fas fa-search"></i>
                      </button>
                    </fieldset>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <Header />

        {/* page-title */}
        <section className="page-title">
          <div
            className="bg-layer"
            style={{ backgroundImage: `url("assets/images/background/page-title.jpg")` }}
          ></div>
          <div className="line-grid-wrap">
            <span className="line-grid-1"></span>
            <span className="line-grid-2"></span>
            <span className="line-grid-3"></span>
            <span className="line-grid-4"></span>
            <span className="line-grid-5"></span>
          </div>
          <div className="auto-container">
            <div className="content-box">
              <h1 style={{ textAlign: 'left' }}>Business Solutions</h1>
              <ul className="bread-crumb clearfix">
                <li>
                  <a href="index.html">Home</a>
                </li>
                <li>Business Solutions</li>
              </ul>
            </div>
          </div>
        </section>
        {/* Page Title End */}

        {/* Main Content Section */}
        <section className="business-content">
          <div className="content-container">
            {/* Tri-Factor Strategy Section */}
            <motion.div
              className="content-section"
              initial="hidden"
              animate="visible"
              variants={sectionVariants}
            >
              <motion.div variants={fadeIn} className="section-header">
                <h2>Tri-Factor Wealth Strategy</h2>
                <p className="subtitle">
                  A transformative financial structure to protect assets, reduce taxes, and grow
                  long-term wealth.
                </p>
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('triFactorOverview')}
                >
                  <h3>Overview of Tri-Factor Strategy</h3>
                  <span
                    className={`toggle-icon ${expandedSections['triFactorOverview'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['triFactorOverview'] && (
                  <div className="section-content">
                    <p>
                      Developed by tax attorney and CPA Mark J. Kohler, the Tri-Factor Strategy
                      integrates three key elements:
                    </p>
                    <ul className="styled-list">
                      <li>Your operational business (e.g., LLC or S Corp)</li>
                      <li>A holding company or personal trust</li>
                      <li>Your retirement vehicle (IRA, Roth IRA, 401(k), or HSA)</li>
                    </ul>
                    <p>
                      By linking these 'buckets,' individuals and business owners can build wealth
                      efficiently, reduce taxes, and protect assets, forming a triangle of financial
                      control, tax reduction, and liability separation.
                    </p>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('triFactorExamples')}
                >
                  <h3>Example Applications</h3>
                  <span
                    className={`toggle-icon ${expandedSections['triFactorExamples'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['triFactorExamples'] && (
                  <div className="section-content">
                    <h4>Self-Employed Professional</h4>
                    <p>
                      Imagine Sarah, a self-employed consultant making $150,000/year:
                    </p>
                    <ul className="styled-list">
                      <li>
                        She sets up an S-Corp to pay herself a salary ($60,000) and distributions
                        ($90,000).
                      </li>
                      <li>Contributes $22,500/year to a solo 401(k) + $30,000 employer match.</li>
                      <li>Her trust owns her consulting IP and receives royalty income.</li>
                      <li>Total estimated tax savings: $18,000/year, plus long-term wealth growth.</li>
                    </ul>
                    <h4>Real Estate Investor</h4>
                    <p>
                      A real estate investor forms an LLC for property management, an IUL trust for
                      asset protection, and uses a self-directed IRA to invest in rental properties.
                    </p>
                    <ul className="styled-list">
                      <li>The IRA earns rental income tax-deferred.</li>
                      <li>The trust provides estate planning & creditor protection.</li>
                      <li>The LLC manages operations and provides liability insulation.</li>
                      <li>Estimated annual tax deferral/gain: $25,000+</li>
                    </ul>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('triFactorBenefits')}
                >
                  <h3>Benefits and Implications</h3>
                  <span
                    className={`toggle-icon ${expandedSections['triFactorBenefits'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['triFactorBenefits'] && (
                  <div className="section-content">
                    <p>Tax Implications:</p>
                    <ul className="styled-list">
                      <li>S-Corp salary vs. distribution reduces self-employment tax.</li>
                      <li>Trusts allow income shifting and estate planning.</li>
                      <li>IRAs and HSAs grow tax-free or tax-deferred.</li>
                    </ul>
                    <p>Legal and Asset Protection Benefits:</p>
                    <ul className="styled-list">
                      <li>Business income is separated from personal accounts.</li>
                      <li>Trusts protect from lawsuits, creditors, and probate.</li>
                      <li>Retirement accounts are shielded under federal ERISA laws.</li>
                    </ul>
                    <p>
                      Ravline Corp endorses this model as a practical and empowering strategy,
                      advising clients to consult a wealth consultant for tailored implementation.
                    </p>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="image-wrapper">
                <img
                  src="/assets/images/BS1.jpg"
                  alt="Tri-Factor Strategy Overview"
                  className="content-image"
                  width="600"
                  height="400"
                />
                <div className="image-overlay">
                  <h4>Tri-Factor Benefits</h4>
                  <ul>
                    <li>Reduces taxes through strategic income shifting.</li>
                    <li>Protects assets with trusts and retirement accounts.</li>
                    <li>Enhances wealth growth with tax-deferred investments.</li>
                  </ul>
                </div>
              </motion.div>
            </motion.div>

            {/* Loan Calculations Section */}
            <motion.div
              className="content-section"
              initial="hidden"
              animate="visible"
              variants={sectionVariants}
            >
              <motion.div variants={fadeIn} className="section-header">
                <h2>Auto & Equipment Loan Calculations</h2>
                <p className="subtitle">
                  Master the math behind auto and equipment loans to optimize your business financing.
                </p>
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('autoLoanCalc')}
                >
                  <h3>Auto Loan Calculation</h3>
                  <span
                    className={`toggle-icon ${expandedSections['autoLoanCalc'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['autoLoanCalc'] && (
                  <div className="section-content">
                    <p>
                      Formula: P = (r * PV) / (1 - (1 + r)^(-n)) where P = monthly payment, r =
                      monthly interest rate, PV = loan amount, n = number of payments.
                    </p>
                    <ul className="styled-list">
                      <li>Loan Amount: $30,000</li>
                      <li>APR: 6% (Monthly Rate: 0.005)</li>
                      <li>Term: 60 months</li>
                      <li>Monthly Payment: ~$580.54</li>
                      <li>Total Paid: $34,832</li>
                      <li>Total Interest: $4,832</li>
                    </ul>
                    <p>Tip: Use extra payments or biweekly payments to reduce total interest.</p>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('equipmentLoanCalc')}
                >
                  <h3>Commercial Equipment Loan</h3>
                  <span
                    className={`toggle-icon ${expandedSections['equipmentLoanCalc'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['equipmentLoanCalc'] && (
                  <div className="section-content">
                    <ul className="styled-list">
                      <li>Equipment Cost: $75,000</li>
                      <li>Down Payment: 20% ($15,000)</li>
                      <li>Loan Amount: $60,000</li>
                      <li>Interest Rate: 8% (Monthly Rate: 0.00667)</li>
                      <li>Term: 60 months</li>
                      <li>Monthly Payment: ~$1,216.57</li>
                      <li>Total Paid: $72,994.20</li>
                      <li>Total Interest: $12,994.20</li>
                    </ul>
                    <p>Key Considerations:</p>
                    <ul className="styled-list">
                      <li>Equipment value and depreciation schedule</li>
                      <li>Loan amount and collateral</li>
                      <li>Interest rate (6% to 12%)</li>
                      <li>Term length (2 to 7 years)</li>
                      <li>Down payment (10% - 30% often required)</li>
                    </ul>
                    <p>Tax Implications:</p>
                    <ul className="styled-list">
                      <li>
                        Section 179 allows full equipment deduction (up to $1.22M in 2024).
                      </li>
                      <li>Reduces taxable income for qualified purchases.</li>
                      <li>Depreciation rules apply for assets not fully expensed.</li>
                      <li>Business vehicles over 6,000 lbs may qualify for 100% bonus depreciation.</li>
                    </ul>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="image-wrapper">
                <img
                  src="/assets/images/BS2.jpg"
                  alt="Loan Calculation Example"
                  className="content-image"
                  width="600"
                  height="400"
                />
                <div className="image-overlay">
                  <h4>Loan Insights</h4>
                  <ul>
                    <li>Auto loan saves with extra payments.</li>
                    <li>Equipment loans offer tax deductions.</li>
                    <li>Optimize with down payments and terms.</li>
                  </ul>
                </div>
              </motion.div>
            </motion.div>

            {/* Financial Documents Section */}
            <motion.div
              className="content-section"
              initial="hidden"
              animate="visible"
              variants={sectionVariants}
            >
              <motion.div variants={fadeIn} className="section-header">
                <h2>Mastering Business Financial Documents</h2>
                <p className="subtitle">
                  Essential records for financial decision-making and lender evaluation.
                </p>
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('incomeStatement')}
                >
                  <h3>Income Statement (Profit & Loss)</h3>
                  <span
                    className={`toggle-icon ${expandedSections['incomeStatement'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['incomeStatement'] && (
                  <div className="section-content">
                    <p>
                      Shows a company's revenue and expenses over a period (monthly, quarterly, or
                      annually).
                    </p>
                    <p>Best Practices:</p>
                    <ul className="styled-list">
                      <li>Set quarterly and annual budgets.</li>
                      <li>Review monthly.</li>
                      <li>Use software like QuickBooks or Excel to visualize trends.</li>
                    </ul>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('generalLedger')}
                >
                  <h3>General Ledger</h3>
                  <span
                    className={`toggle-icon ${expandedSections['generalLedger'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['generalLedger'] && (
                  <div className="section-content">
                    <p>Master record for all financial transactions.</p>
                    <p>Best Practices:</p>
                    <ul className="styled-list">
                      <li>Maintain detailed entries with dates and descriptions.</li>
                      <li>Reconcile monthly with bank statements.</li>
                      <li>Use for audit tracking and accounting transparency.</li>
                    </ul>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('taxDocuments')}
                >
                  <h3>Tax Documents</h3>
                  <span
                    className={`toggle-icon ${expandedSections['taxDocuments'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['taxDocuments'] && (
                  <div className="section-content">
                    <p>
                      Includes business tax returns (1120-S, 1065, Schedule C), estimated tax
                      payments, and supporting schedules.
                    </p>
                    <p>Key Notes:</p>
                    <ul className="styled-list">
                      <li>Must align with internal books.</li>
                      <li>Underwriters use tax filings to validate reported income.</li>
                      <li>Accurate reporting reduces audit risk and penalties.</li>
                    </ul>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="expandable-section">
                <div
                  className="section-header-toggle"
                  onClick={() => toggleSection('lendingPerspective')}
                >
                  <h3>Lending & Underwriting Perspective</h3>
                  <span
                    className={`toggle-icon ${expandedSections['lendingPerspective'] ? 'rotated' : ''}`}
                  >
                    ▼
                  </span>
                </div>
                {expandedSections['lendingPerspective'] && (
                  <div className="section-content">
                    <p>Lenders typically request:</p>
                    <ul className="styled-list">
                      <li>Last 2 years' tax returns</li>
                      <li>YTD income statement and balance sheet</li>
                      <li>Bank statements</li>
                      <li>Debt schedules</li>
                    </ul>
                    <p>Underwriting Metrics:</p>
                    <ul className="styled-list">
                      <li>DSCR (Debt Service Coverage Ratio): Must be 1.25</li>
                      <li>Net Operating Income</li>
                      <li>Gross Margin</li>
                      <li>EBITDA</li>
                    </ul>
                    <p>Example:</p>
                    <ul className="styled-list">
                      <li>
                        Business A applies for a $150,000 loan with an annual net profit of $60,000
                        and monthly debt payments of $3,000.
                      </li>
                    </ul>
                  </div>
                )}
              </motion.div>

              <motion.div variants={fadeIn} className="image-wrapper">
                <img
                  src="/assets/images/BS3.jpg"
                  alt="Financial Documents Overview"
                  className="content-image"
                  width="600"
                  height="400"
                />
                <div className="image-overlay">
                  <h4>Document Benefits</h4>
                  <ul>
                    <li>Income statements guide budgeting.</li>
                    <li>Ledgers ensure transparency.</li>
                    <li>Tax documents reduce audit risk.</li>
                  </ul>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>

        <Footer />

        {/* Scroll to top */}
        <div
          className="scroll-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{ cursor: 'pointer' }}
        >
          <div>
            <div className="scroll-top-inner">
              <div className="scroll-bar">
                <div className="bar-inner"></div>
              </div>
              <div className="scroll-bar-text">Go To Top</div>
            </div>
          </div>
        </div>
        {/* Scroll to top end */}
      </div>
    </div>
  );
}